import React from 'react';
import PropTypes from 'prop-types';

// The official IronSight symbol (corner bracket + offset square) as a tiny
// inline mark for card eyebrows and headings. currentColor so it inherits
// the eyebrow's ink (cream on the hunter card heads).
//
// Size arrives as a DEFAULT PARAMETER, not defaultProps: React 19 ignores
// defaultProps on function components, which left the svg without width or
// height and let it explode to container size. The inline style is the
// belt-and-braces guarantee that no stylesheet can resize it either.
function IronSightMark({ size = 11 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            aria-hidden="true"
            focusable="false"
            style={{ width: size, height: size, verticalAlign: '-0.08em', flexShrink: 0 }}
        >
            {/* Official IronSight corner bracket — the L-mark from the top-left of
                the wordmark (Branding/IronSight.png), geometry measured 1:1. */}
            <path d="M8 14H56V29H26V50H8Z" fill="currentColor" />
        </svg>
    );
}

IronSightMark.propTypes = { size: PropTypes.number };

export default IronSightMark;
